export const BLOCK_ID = "blockId";
export const BLOCK_NAME = "blockName";
export const DESCRIPTION = "description";
export const COMMUNITY_ID = "communityId";
export const ZONE_ID = "zoneId";
export const LIST = "blocks";
export const NEW = "isNew";
export const DELETED = "isDeleted"
